module.exports = __webpack_public_path__ + "img/csomagjaink__also_bg_1920.158ce5c5.jpg";